export function pluralise(word: string, count: number): string {
  switch (word) {
    case 'this':
      return count > 1 ? 'these' : word;
    default:
      return count === 1 ? word : word + 's';
  }
}
